import React from 'react';
import { Card } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { userUrl } from '@/constants/urls';
import { tokenStatus } from '../constants';
import myTokens from '../helper';

const TokenCardCardExtra = ({ category, token, allowUserLink }) => {
  const intl = useIntl();
  return (
    <>
      {myTokens(category) && (
        <Card.Content
          extra
          content={intl.formatMessage({ id: `status.${token.active ? tokenStatus.ACTIVE : tokenStatus.EXPIRED}` })}
        />
      )}
      {!myTokens(category) && !allowUserLink && (
        <Card.Content extra content={intl.formatMessage({ id: 'token.who.user' }, { user: token.user.name })} />
      )}
      {!myTokens(category) && allowUserLink && (
        <Card.Content extra>
          <FormattedMessage id="token.who" />
          <Link to={userUrl(token.user)} title={token.user.name}>
            {token.user.name}
          </Link>
        </Card.Content>
      )}
    </>
  );
};

export default TokenCardCardExtra;
